export default __webpack_public_path__ + "assets/images/1496a12522f58948a645993f8c49098a.jpg";